import { Injectable } from '@angular/core';

import { PatientGroup } from '../../../../../../data/dietitian/domain/patient_group/patient_group';
import { ConversationCommands } from '../../../../../../data/message/domain/conversation/conversation_commands';
import { Patient } from '../../../../../../data/patient/domain/patient';
import { PatientStateProvider } from '../../../../../../data/patient/domain/patient_state_provider';
import { ConversationModel } from '../../../../../components/message/message.models';
import { SortListType } from '../../questions.service';

export interface PatientInfoViewModel {
  isLoading: boolean;
  error: string;
  patient: Patient;
}

@Injectable()
export class QuestionsListFacade {
  isLoading = false;

  constructor(
    private patientStateProvider: PatientStateProvider,
    private conversationCommands: ConversationCommands,
  ) {
    // do nothing
  }

  async getAllConversations(
    type?: SortListType,
    patientGroup?: PatientGroup,
  ): Promise<ConversationModel[]> {
    const conversations =
      await this.conversationCommands.findDietitianConversations(
        type,
        patientGroup,
      );

    return conversations.map((message) => {
      return {
        id: message.conversationId.id.toString(),
        patientAvatarUrl: message.patient?.profilePicture,
        name: message.patient?.fullName,
        subject: message.subject,
        lastMessageDate: message.updatedAt,
        initials: message.patient?.initials,
        new: message.dietitian.hasNewMessage,
        closed: message.closed,
        patientId: message.patient?.profileId.id.toString(),
      } as ConversationModel;
    });
  }
}
